import PageTemplate from '@/components/ui/PageTemplate';
import useObserver from '@/hooks/page/useObserver';

// Exportable content component without PageTemplate wrapper
export const BuildingTrustContent = () => {
  useObserver('content-BuildingTrust', 'content-BuildingTrust-tablet', 'content-BuildingTrust-desktop');

  return (
    <>
      {/* Mobile Layout */}
      <div
        id='content-BuildingTrust'
        className='md:hidden w-full min-h-screen flex flex-col justify-center items-center py-20 gap-6 relative'
      >
        <div className='flex flex-col justify-center items-center gap-10 relative z-10 text-center max-w-[320px] mx-auto w-full'>
          <div className='flex flex-col px-4'>
            <p className='text-[28px] font-semibold text-white'>
              Building Trust
            </p>
            <p className='text-[28px] font-semibold text-white'>
              in Zero-trust Space
            </p>
          </div>
          <p className='text-xl font-semibold text-white'>Never trust!</p>
          <div className='flex flex-col justify-center items-center px-4'>
            <p className='text-sm font-medium text-white'>
              Verify using our innovative platform and algorithms. We build
              trust in the space environment with full of uncertainties, delayed
              certainties, and deceived certainties with our real-time
              spatiotemporal reasoning capabilities.
            </p>
          </div>
        </div>
      </div>

      {/* Tablet & Desktop Layout */}
      <div
        id='content-BuildingTrust-desktop'
        className='hidden md:flex w-full h-screen relative'
      >
        <div className='w-full md:max-w-[688px] xl:max-w-[1060px] mx-auto flex flex-col justify-center items-center py-36 gap-8'>
        <div className='flex flex-col justify-center items-center gap-14 md:max-w-[688px] xl:max-w-[1280px] relative z-10'>
          <p className='xl:text-4xl md:text-[40px] font-semibold text-white text-center'>
            Building Trust in Zero-Trust Space
          </p>
          <p className='xl:text-2xl md:text-[30px] font-semibold text-white'>Never trust!</p>
          <div className='xl:flex hidden flex-col justify-center items-center gap-2'>
            <p className='text-2xl font-medium text-white text-center xl:whitespace-nowrap'>
              Verify using our innovative platform and algorithms.
            </p>
            <p className='text-2xl font-medium text-white text-center xl:whitespace-nowrap'>
              We build trust in the space environment with full of
              uncertainties, delayed certainties,
            </p>
            <p className='text-2xl font-medium text-white text-center xl:whitespace-nowrap'>
              and deceived certainties with our real-time spatiotemporal
              reasoning capabilities.
            </p>
          </div>
          <div className='xl:hidden flex flex-col justify-center items-center'>
            <p className='text-[26px] font-medium text-white text-center xl:whitespace-nowrap'>
              Verify using our innovative platform and algorithms.
            </p>
            <p className='text-[26px] font-medium text-white text-center xl:whitespace-nowrap'>
              We build trust in the space environment with full of
              uncertainties, delayed certainties,
            </p>
            <p className='text-[26px] font-medium text-white text-center xl:whitespace-nowrap'>
              and deceived certainties with our real-time spatiotemporal
              reasoning capabilities.
            </p>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

// Original component with PageTemplate wrapper
const BuildingTrust = () => {
  return (
    <PageTemplate id='Building Trust'>
      <BuildingTrustContent />
    </PageTemplate>
  );
};

export default BuildingTrust;
